import { useEffect } from 'react';
import { useLocation, useNavigate, useParams } from '@tanstack/react-router';
import { useMyStudentProfileQuery } from '../hooks/use-student-profile-queries';

function isNotFoundError(error: unknown): boolean {
  return typeof error === 'object' && error !== null && 'status' in error && error.status === 404;
}

export function StudentProfileOnboardingGate({ enabled }: { enabled: boolean }) {
  const { tenantId = '' } = useParams({ strict: false });
  const location = useLocation();
  const navigate = useNavigate();
  const profileQuery = useMyStudentProfileQuery({ enabled });

  useEffect(() => {
    if (!enabled || !isNotFoundError(profileQuery.error) || location.pathname.endsWith('/student-profile/onboarding')) return;
    void navigate({ to: '/w/$tenantId/student-profile/onboarding', params: { tenantId }, replace: true });
  }, [enabled, location.pathname, navigate, profileQuery.error, tenantId]);

  return null;
}
